












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'VGoalItem'
})
export default class VGoalItem extends Vue {
  @Prop({ required: true }) data?: {
    id: string;
    year: string;
    content: string;
    isLinked: boolean;
    percentCompleted: string;
  };
}
